import React from 'react';
import Icon from 'components/AppIcon';

const formatRelativeTime = (dateStr) => {
  if (!dateStr) return '';
  const now = new Date();
  const date = new Date(dateStr);
  const diffMs = now - date;
  const diffSecs = Math.floor(diffMs / 1000);
  const diffMins = Math.floor(diffSecs / 60);
  const diffHours = Math.floor(diffMins / 60);
  const diffDays = Math.floor(diffHours / 24);

  if (diffSecs < 60) return 'just now';
  if (diffMins < 60) return `${diffMins}m ago`;
  if (diffHours < 24) return `${diffHours}h ago`;
  if (diffDays < 7) return `${diffDays}d ago`;
  return date?.toLocaleDateString([], { month: 'short', day: 'numeric' });
};

const MessageBubble = ({ message, isOwn, onPin, canPin }) => {
  const relativeTime = formatRelativeTime(message?.created_at);
  const isPending = message?.isPending;
  const isFailed = message?.isFailed;

  return (
    <div
      className={`group flex gap-2 ${
        message?.is_announcement
          ? 'bg-yellow-500/5 border border-yellow-500/20 rounded-lg p-3 mx-0'
          : isOwn
          ? 'flex-row-reverse' :''
      }`}
    >
      {/* Avatar */}
      {!isOwn && (
        <div className="w-8 h-8 rounded-full bg-primary/20 flex items-center justify-center flex-shrink-0 mt-1">
          <span className="text-xs font-bold text-primary">
            {(message?.user_profiles?.username || message?.sender_id?.slice(0, 2) || '?')?.charAt(0)?.toUpperCase()}
          </span>
        </div>
      )}

      <div className={`min-w-0 flex flex-col ${
        isOwn ? 'items-end max-w-[70%]' : 'items-start max-w-[70%]'
      }`}>
        {/* Sender + Time */}
        {!isOwn && (
          <div className="flex items-center gap-2 mb-0.5">
            <span className="text-xs font-semibold text-primary">
              {message?.user_profiles?.username || 'Member'}
            </span>
            {message?.is_announcement && (
              <span className="text-xs px-1.5 py-0.5 rounded bg-yellow-500/20 text-yellow-400 font-medium">
                📌 Pinned
              </span>
            )}
            <span className="text-xs text-muted-foreground">{relativeTime}</span>
          </div>
        )}

        {/* Message bubble */}
        <div
          className={`relative px-3 py-2 rounded-lg break-words ${
            isOwn
              ? 'bg-primary text-primary-foreground rounded-tr-none'
              : message?.is_announcement
              ? 'bg-yellow-500/10 text-foreground border border-yellow-500/20'
              : 'bg-card border border-border text-foreground rounded-tl-none'
          } ${
            isPending ? 'opacity-70' : ''
          } ${
            isFailed ? 'border-red-500/40 bg-red-500/5' : ''
          }`}
          style={{ fontSize: '14px', lineHeight: '1.5', wordBreak: 'break-word' }}
        >
          {message?.message_text}

          {/* Own message time + status */}
          {isOwn && (
            <div className="flex items-center justify-end gap-1 mt-0.5">
              <span className="text-xs opacity-70">{relativeTime}</span>
              {isPending && <Icon name="Clock" size={10} color="currentColor" />}
              {isFailed && <Icon name="AlertCircle" size={10} color="#f87171" />}
              {!isPending && !isFailed && <Icon name="Check" size={10} color="currentColor" />}
            </div>
          )}
        </div>

        {/* Pin action */}
        {canPin && !message?.is_announcement && !isOwn && (
          <button
            onClick={() => onPin?.(message?.id)}
            className="mt-1 text-xs text-muted-foreground hover:text-yellow-400 opacity-0 group-hover:opacity-100 transition-all flex items-center gap-1 min-h-[28px]"
          >
            <Icon name="Pin" size={10} />
            Pin
          </button>
        )}
      </div>
    </div>
  );
};

export default MessageBubble;
